import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-05a6646d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "branding" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Music")
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "dropdown-nav" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Music")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ 'scrolled-nav': _ctx.state.scrolledNav })
  }, [
    _createElementVNode("nav", null, [
      _hoisted_1,
      _withDirectives(_createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: {
              name: 'home',
            } }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: {
              name: 'about',
            } }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, { to: {
              name: 'music',
            } }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, !_ctx.state.mobile]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("i", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args))),
          class: _normalizeClass(
            _ctx.state.mobileNav === false
              ? 'far fa-bars'
              : 'fas fa-times icon-active'
          )
        }, null, 2), [
          [_vShow, _ctx.state.mobile]
        ])
      ]),
      _createVNode(_Transition, { name: "mobile-nav" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
            }, [
              _createVNode(_component_router_link, { to: {
                name: 'home',
              } }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
            }, [
              _createVNode(_component_router_link, { to: {
                name: 'about',
              } }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
            }, [
              _createVNode(_component_router_link, { to: {
                name: 'music',
              } }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.state.mobileNav]
          ])
        ]),
        _: 1
      })
    ])
  ], 2))
}